(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sv", [], factory);
	else if(typeof exports === 'object')
		exports["sv"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["sv"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 